import React from 'react'
import { Typography } from '@the-platform-group/component-library'
import { usePeopleMergeContext } from '../../contexts/PeopleMergeContext'
import { getProfileFieldValue } from '../../utils'
import { PEOPLE_COMPARISON_FIELDS } from '../../constants'
import ProfileComparisonTable from '../ProfileComparisonTable'
import MultipleJobsRow from './MultipleJobsRow'
import { StyledCell } from '../ComparisonRow'

const ComparisonTable = () => {
  const { mergeData } = usePeopleMergeContext()
  const { sourcePerson, targetPerson, preview } = mergeData

  if (!sourcePerson || !targetPerson) {
    return null
  }

  const renderSpecialField = field => {
    // Handle Multiple Jobs accordion
    if (field.key === 'multipleJobs') {
      return <MultipleJobsRow label={field.label} />
    }

    return null
  }

  const renderFieldValue = field => {
    const sourceValue = getProfileFieldValue({
      person: sourcePerson,
      preview,
      fieldKey: field.key,
      isSource: true,
    })
    const targetValue = getProfileFieldValue({
      person: targetPerson,
      preview,
      fieldKey: field.key,
      isSource: false,
    })

    return (
      <>
        <StyledCell item xs={5}>
          <Typography variant="body2">{sourceValue}</Typography>
        </StyledCell>
        <StyledCell item xs={5}>
          <Typography variant="body2">{targetValue}</Typography>
        </StyledCell>
      </>
    )
  }

  return (
    <ProfileComparisonTable
      fields={PEOPLE_COMPARISON_FIELDS}
      renderFieldValue={renderFieldValue}
      renderSpecialField={renderSpecialField}
      headers={['', 'Platform Profile', 'Factset Profile']}
      columnWidths={[2, 5, 5]}
    />
  )
}

export default ComparisonTable
